import t from "./ghl-ui.es731.js";
import o from "./ghl-ui.es732.js";
import f from "./ghl-ui.es733.js";
import i from "./ghl-ui.es419.js";
import e from "./ghl-ui.es734.js";
function c(r) {
  return typeof r == "function" ? r : r == null ? f : typeof r == "object" ? i(r) ? o(r[0], r[1]) : t(r) : e(r);
}
export {
  c as default
};
